import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Building2, UserCircle, MessageCircle } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { employees } from '../data';
export function ProfilePage() {
  const {
    id
  } = useParams();
  const person = employees.find(e => e.id === id);
  if (!person) {
    return <div className="text-center py-20" data-id="element-578">
        <p className="text-navy-500 mb-4" data-id="element-579">That person couldn't be found.</p>
        <Link to="/people" className="text-gold-600 font-semibold" data-id="element-580">
          Back to People
        </Link>
      </div>;
  }
  const reports = employees.filter(e => e.manager === person.name);
  const teammates = employees.filter(e => e.department === person.department && e.id !== person.id).slice(0, 4);
  return <div className="max-w-3xl mx-auto" data-id="element-581">
      <PageHeader title="" backTo="/people" backLabel="Back to People" data-id="element-582" />

      <div className="bg-white rounded-2xl border border-navy-100 overflow-hidden" data-id="element-583">
        <div className="h-28 bg-navy-600" data-id="element-584" />
        <div className="px-6 pb-6" data-id="element-585">
          <img src={person.avatar} alt={person.name} className="w-28 h-28 rounded-full object-cover ring-4 ring-white -mt-14" data-id="element-586" />
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mt-3" data-id="element-587">
            <div data-id="element-588">
              <h1 className="text-2xl font-serif font-bold text-navy-900" data-id="element-589">
                {person.name}
              </h1>
              <p className="text-navy-500" data-id="element-590">{person.title}</p>
            </div>
            <div className="flex gap-2" data-id="element-591">
              <a href={`mailto:${person.email}`} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-colors" data-id="element-592">
                <Mail className="w-4 h-4" data-id="element-593" /> Email
              </a>
              <button className="inline-flex items-center gap-2 px-4 py-2 text-sm font-bold text-navy-700 bg-navy-50 rounded-lg hover:bg-navy-100 transition-colors" data-id="element-594">
                <MessageCircle className="w-4 h-4" data-id="element-595" /> Message
              </button>
            </div>
          </div>

          <dl className="grid sm:grid-cols-2 gap-4 mt-6 pt-6 border-t border-navy-100 text-sm" data-id="element-596">
            <div className="flex items-center gap-3" data-id="element-597">
              <Building2 className="w-5 h-5 text-navy-400" data-id="element-598" />
              <div data-id="element-599">
                <dt className="text-navy-400 text-xs" data-id="element-600">Department</dt>
                <dd className="font-semibold text-navy-900" data-id="element-601">
                  {person.department}
                </dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-602">
              <MapPin className="w-5 h-5 text-navy-400" data-id="element-603" />
              <div data-id="element-604">
                <dt className="text-navy-400 text-xs" data-id="element-605">Location</dt>
                <dd className="font-semibold text-navy-900" data-id="element-606">
                  {person.location}
                </dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-607">
              <Mail className="w-5 h-5 text-navy-400" data-id="element-608" />
              <div data-id="element-609">
                <dt className="text-navy-400 text-xs" data-id="element-610">Email</dt>
                <dd className="font-semibold text-navy-900" data-id="element-611">{person.email}</dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-612">
              <Phone className="w-5 h-5 text-navy-400" data-id="element-613" />
              <div data-id="element-614">
                <dt className="text-navy-400 text-xs" data-id="element-615">Phone</dt>
                <dd className="font-semibold text-navy-900" data-id="element-616">{person.phone}</dd>
              </div>
            </div>
            {person.manager && <div className="flex items-center gap-3" data-id="element-617">
                <UserCircle className="w-5 h-5 text-navy-400" data-id="element-618" />
                <div data-id="element-619">
                  <dt className="text-navy-400 text-xs" data-id="element-620">Reports to</dt>
                  <dd className="font-semibold text-navy-900" data-id="element-621">
                    {person.manager}
                  </dd>
                </div>
              </div>}
          </dl>
        </div>
      </div>

      {reports.length > 0 && <div className="mt-8" data-id="element-622">
          <h2 className="text-lg font-serif font-bold text-navy-900 mb-3" data-id="element-623">
            Direct Reports
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-624">
            {reports.map(r => <Link key={r.id} to={`/people/${r.id}`} className="flex items-center gap-2 bg-white rounded-lg border border-navy-100 p-3 hover:border-gold-400 transition-colors" data-id="element-625">
                <img src={r.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-626" />
                <div className="min-w-0" data-id="element-627">
                  <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-628">
                    {r.name}
                  </p>
                  <p className="text-xs text-navy-400 truncate" data-id="element-629">{r.title}</p>
                </div>
              </Link>)}
          </div>
        </div>}

      {teammates.length > 0 && <div className="mt-8" data-id="element-630">
          <h2 className="text-lg font-serif font-bold text-navy-900 mb-3" data-id="element-631">
            In {person.department}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-632">
            {teammates.map(t => <Link key={t.id} to={`/people/${t.id}`} className="flex items-center gap-2 bg-white rounded-lg border border-navy-100 p-3 hover:border-gold-400 transition-colors" data-id="element-633">
                <img src={t.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-634" />
                <div className="min-w-0" data-id="element-635">
                  <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-636">
                    {t.name}
                  </p>
                  <p className="text-xs text-navy-400 truncate" data-id="element-637">{t.title}</p>
                </div>
              </Link>)}
          </div>
        </div>}
    </div>;
}